import { control } from 'leaflet';
import { useMap } from 'react-leaflet';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';

interface FullscreenControlProps {
    mapRef: any;
}
const FullscreenControl: React.FC<FullscreenControlProps> = ({ mapRef }) => {
    const map = useMap();
    //@ts-ignore
    if (mapRef && !mapRef.current) {
        //@ts-ignore
        mapRef.current = control
            .fullscreen({
                position: 'topleft',
            })
            .addTo(map);
    }
    return null;
};

export default FullscreenControl;
